export const iconFontAwesomeUsersPeopleUserTie = (
	<i className="fa-solid fa-user-tie"></i>
);
